// src/modules/application/utils/files.ts
export function fileUrl(path?: string | null) {
  if (!path) return null;

  // If backend already returns full URL
  if (path.startsWith("http://") || path.startsWith("https://")) return path;

  // Prefer a dedicated files base if you have one
  const base =
    process.env.REACT_APP_API_URL_FOR_IMAGE ||
    process.env.REACT_APP_API_URL_FOR_IMAGE ||
    "";

  // Remove trailing /api if your VITE_API_URL includes it
  const cleaned = base.replace(/\/api\/?$/, "");

  return `${cleaned}/storage/${path}`;
}
